
export interface MaterialSubCategoryType {
    id: number;
    category_id: number | null;
    sub_category_name: string | null;
    status: 1 | 0;
    created_by: number | null;
}

// to single object maping
export const mapMaterialSubCategoryType = (data: any): MaterialSubCategoryType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialSubCategoryType: MaterialSubCategoryType = {
        id: data.id,
        sub_category_name: data.sub_category_name || null,
        category_id: data.category_id || null,
        status: data.status,
        created_by: data.created_by || null,
    }

    return materialSubCategoryType;
}

// maping list objects
export const mapMaterialSubCategoryTypes = (data: any[]): MaterialSubCategoryType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialSubCategoryType);
}